export const settings = {
    url: "https://doc.refal.ch/",
    webapi: "ARXivarNextWebApi",
    idClassCV: 90,
    IdProfiloCV: 27,
    IdProfiloLet: 30,
    IdProfiloAltri: 29
}